import { Brain } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const daLiMiJePotrebanPsiholog: QuizConfig = {
  id: "da-li-mi-je-potreban-psiholog",
  illustration: {
    src: "/images/quizzes/da-li-mi-je-potreban-psiholog.webp",
    alt: "Žena započinje razgovor sa psihoterapeutom u mirnoj sobi.",
  },
  lastModified: "2026-07-18",
  title: "Da li ti je potreban psiholog? Brzi test za samoprocenu",
  shortTitle: "Da li ti je potreban psiholog?",
  description:
    "Proveri da li bi ti razgovor sa psihologom mogao pomoći da lakše prebrodiš trenutne izazove.",
  longDescription:
    "Ako nisi siguran/na da li je vreme da razgovaraš sa psihologom, ovaj test te vodi kroz ključne znakove koji ukazuju da je podrška stručnjaka korisna. Analiziramo tvoje obrasce razmišljanja, fizičke simptome i nivo podrške okoline kako bi shvatio/la da li trenutno možeš sam/a ili bi ti značilo da se osloniš na profesionalnu pomoć. Na kraju dobijaš jasan rezime, plan prvih koraka i opciju da se povežeš sa licenciranim psiholozima koji razumeju izazove kroz koje prolaziš.",
  icon: Brain,
  duration: "2-4 min",
  category: "Mentalno zdravlje",
  focusAreasWanted: ["emotional_regulation", "depression", "anxiety", "stress"],
  safety: {
    urgentOptionTexts: ["Razmišljaš o samopovređivanju ili smrti"],
  },
  featured: true,
  questions: [
    {
      type: "radio",
      question:
        "Da li ti je teško da se sam/a nosiš sa svojim emocijama ili problemima?",
      options: ["Da, često", "Ponekad", "Retko", "Ne"],
      scores: [3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koje od ovih stvari si primetio/la u poslednjih mesec dana? (označi sve što važi)",
      options: [
        "Problemi sa spavanjem (previše ili premalo sna)",
        "Promene u apetitu ili težini",
        "Osećaj beznadežnosti ili bezvrednosti",
        "Ne radiš više stvari koje su te ranije radovale",
        "Teško ti je da održavaš odnose sa drugima",
        "Teško se koncentrišeš ili donosiš odluke",
        "Razmišljaš o samopovređivanju ili smrti",
        "Ništa od navedenog",
      ],
      scores: [1, 1, 2, 2, 2, 1, 3, 0],
    },
    {
      type: "radio",
      question:
        "Koliko često tvoje emotivno stanje utiče na svakodnevni život (posao, školu, odnose)?",
      options: [
        "Svaki dan",
        "Nekoliko puta nedeljno",
        "Nekoliko puta mesečno",
        "Retko ili nikad",
      ],
      scores: [3, 2, 1, 0],
    },
    {
      type: "radio",
      question:
        "Jesi li nekad pričao/la sa nekim o svojim emocionalnim poteškoćama?",
      options: [
        "Da, sa stručnjakom",
        "Da, sa prijateljima/porodicom",
        "Ne, ali želim",
        "Ne, ne osećam potrebu",
      ],
      scores: [1, 1, 2, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Šta radiš kad ti je teško? (označi sve što važi)",
      options: [
        "Povučem se od drugih ljudi",
        "Pijem alkohol ili koristim druge supstance",
        "Prejedam se ili preskačem obroke",
        "Pričam sa bliskim osobama",
        "Vežbam ili se bavim sportom",
        "Meditiram ili radim vežbe disanja",
        "Bavim se kreativnim aktivnostima",
        "Nemam načina da se izborim sa teškim emocijama",
      ],
      scores: [2, 3, 2, 0, 0, 0, 0, 2],
    },
    {
      type: "radio",
      question: "Koliko si bio/la anksiozan/na u poslednjih mesec dana?",
      options: ["Baš mnogo", "Dosta", "Umereno", "Malo", "Nisam uopšte"],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Imaš li podršku bliskih osoba kad ti je teško?",
      options: ["Da, uvek", "Uglavnom da", "Retko", "Ne"],
      scores: [0, 1, 2, 3],
    },
    {
      type: "textarea",
      question: "Šta te trenutno najviše brine u vezi tvog mentalnog zdravlja?",
    },
  ],
  copy: {
    title: "Tvoji rezultati",
    subtitle: "Analiza tvog mentalnog stanja i sledeći koraci",
    scoreLabel: "Da li ti je potreban psiholog?",
    adviceTitle: "Saveti za tebe",
    resourcesTitle: "Predlažemo da pročitaš:",
    whatNextTitle: "Šta dalje?",
    shareButtonText: "Podeli rezultat",
  },
};
